import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
    Grid,
    Box,
    Typography,
    Button,
    Paper,
    Divider,
    Stack
} from "@mui/material";


import {
    BarLoader,
    BeatLoader,
    BounceLoader,
    CircleLoader,
    ClimbingBoxLoader,
    ClipLoader,
    ClockLoader,
    DotLoader,
    FadeLoader,
    GridLoader,
    HashLoader,
    MoonLoader,
    PacmanLoader,
    PropagateLoader,
    PuffLoader,
    PulseLoader,
    RingLoader,
    RiseLoader,
    RotateLoader,
    ScaleLoader,
    SyncLoader
} from "react-spinners"

const loaders = [
    BarLoader,
    BeatLoader,
    BounceLoader,
    CircleLoader,
    ClimbingBoxLoader,
    ClipLoader,
    ClockLoader,
    DotLoader,
    FadeLoader,
    GridLoader,
    HashLoader,
    MoonLoader,
    PacmanLoader,
    PropagateLoader,
    PuffLoader,
    PulseLoader,
    RingLoader,
    RiseLoader,
    RotateLoader,
    ScaleLoader,
    SyncLoader
]

const loaderNames = {
    'BarLoader': { height: 4, width: 100 },
    'BeatLoader': { size: 15, margin: 2 },
    'BounceLoader': { size: 60 },
    'CircleLoader': { size: 50 },
    'ClimbingBoxLoader': { size: 15 },
    'ClipLoader': { size: 35 },
    'ClockLoader': { size: 50 },
    'DotLoader': { size: 60, margin: 2 },
    'FadeLoader': { height: 15, width: 5, radius: 2, margin: 2 },
    'GridLoader': { size: 15, margin: 2 },
    'HashLoader': { size: 50, margin: 2 },
    'MoonLoader': { size: 60, margin: 2 },
    'PacmanLoader': { size: 25, margin: 2 },
    'PropagateLoader': { size: 15 },
    'PuffLoader': { size: 60 },
    'PulseLoader': { size: 15, margin: 2 },
    'RingLoader': { size: 60, margin: 2 },
    'RiseLoader': { size: 15, margin: 2 },
    'RotateLoader': { size: 15, margin: 2 },
    'ScaleLoader': { height: 15, width: 4, radius: 2, margin: 2 },
    'SyncLoader': { size: 15, margin: 2 },
}

const loaderOptions = Object.keys(loaderNames).map((d, i) => {
    return {
        name: d, component: loaders[i],
        sx: loaderNames[d]
    }
});

const override = (sx) => {
    return {
        ...sx,
        display: "block",
        // margin: "0 auto",
    }

};

export default function LoaderPanel() {

    const theme = useTheme();
    const [selectedLoader, setSelectedLoader] = useState(
        localStorage.getItem('themeLoader') || "CircleLoader");
    const SelectedLoader = loaderOptions.find(l =>
        l.name === selectedLoader).component;

    return (
        <Box sx={{ p: 4,  }}>
            <Typography variant="h5" gutterBottom>
                Choose a Loader
            </Typography>
            <Typography variant="h6" align="center" gutterBottom>
                Selected Loader: {selectedLoader}
            </Typography>
            <Stack justifyContent="center" alignItems="center"

                sx={{
                    height: "10vh"
                }}
            >
                <SelectedLoader color={theme.palette.primary.main}
                    loading={true} />
            </Stack>
            <Divider sx={{ my: 4 }} />

            <Grid container spacing={2}
                sx={{ p: 4, height: "100%", overflow: "auto" }}
            >
                {loaderOptions.map(({ name, component: Loader, sx }) => (
                    <Grid sx={{xs:6}} key={name}>
                        <Paper elevation={3} sx={{
                            sm:3,
                            p: 1, textAlign: "center",
                            width: "10vw", height: "20vh",

                        }}>
                            <Stack
                                sx={{ width: "100%", height: "100%", }}
                                direction="column"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Box
                                    direction="column"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Loader
                                        color={theme.palette.primary.main}
                                        cssOverride={override({})}


                                    />
                                </Box>
                                <Stack

                                    direction="column"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography variant="subtitle2"
                                        sx={{ mt: 1 }}>{name}</Typography>
                                    <Button
                                        variant={selectedLoader === name ? "contained" : "outlined"}
                                        onClick={() => {
                                            setSelectedLoader(name);
                                            localStorage.setItem('themeLoader', name);
                                        }}
                                        sx={{
                                            mt: 1,
                                            fontSize: "0.7em",

                                        }}
                                        size="small"
                                    >
                                        {selectedLoader === name ? "Selected" :
                                            "Select"}
                                    </Button>
                                </Stack>
                            </Stack>
                        </Paper>
                    </Grid>
                ))}
            </Grid>


        </Box>
    );
}
